import { useEffect, useState } from "react";
import { getGroupAuthTags } from "../services/groupService";

interface IUseFetchGroupAuthTags {
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  groupId: string | number | null | undefined;
}

const useFetchGroupAuthTags = ({
  setIsLoading,
  groupId,
}: IUseFetchGroupAuthTags) => {
  const [groupAuthTags, setGroupAuthTags] = useState<number[]>([]);

  useEffect(() => {
    if (!groupId) {
      setGroupAuthTags([]);
      return;
    }

    const fetchGroupAuthTags = async () => {
      if (setIsLoading) {
        setIsLoading(true);
      }

      try {
        const response = await getGroupAuthTags(groupId);

        setGroupAuthTags(response || []);
      } catch (err) {
        console.error("Error fetching group tags:", err);
        setGroupAuthTags([]);
      } finally {
        if (setIsLoading) {
          setIsLoading(false);
        }
      }
    };

    fetchGroupAuthTags();
  }, [groupId, setIsLoading]);

  return [groupAuthTags, setGroupAuthTags] as const;
};

export default useFetchGroupAuthTags;
